/*
		form.js,
			Code for handling forms (posted using AJAX).

	To simplify the usage of this class there are some requirements set in stone:
		* There MUST be a <input type="submit" name="submit"> element
		* If a cancelurl is provided then there MUST be a <input type="button" id="cancel">
		* There MUST be a textual element (span,p,...) with id="submitstatus"

 */

var Class = require('./class.js');
var Ajax = require('./ajax.js');
var DOM = require('./dom.js');
var Event = require('./event.js');
var Browser = require('./browser.js');
var $ = require('./base.js').$;

var Form = module.exports = Class(null, {
	__init__: function(name, submiturl, cancelurl, elStatus, elForm) {
		this.submiturl = submiturl;
		this.cancelurl = cancelurl;
		this.sendText = 'Sending...';
		this.elStatus = elStatus || $('submitstatus');

		/* attach ourselves to the submit and cancel buttons */
		this.elForm = elForm || document.forms[name];
		Event.observe(this.elForm, 'submit', this, this.submit);
//		Event.observe(this.element("submit"), 'click', this, this.submit);
		if(cancelurl)
			Event.observe($("cancel"), 'click', this, this.cancel);

		if(! elStatus)		/* newer clients don't want autofocus behaviour, 'cause it messes with multiple forms on a page */
			this.elForm.elements[0].focus();
	},

	set: function(name, value) {
		var el = this.element(name);
		if(! el)
			return false;
		if(el.type.search('select') >= 0) {
			for(var i = 0; i < el.length; i++) {
				if(el.options[i].value == value) {
					el.selectedIndex = i;
					return;
				}
			}
		}
		else if(el.type.search('checkbox') >= 0)
			el.checked = value;
		else{
			el.value = value != null ? value : '';
		}
	},

	element: function(name) {
		ret = this.elForm.elements[name];
		if (!ret){
			for (var i = 0; i < this.elForm.elements.length; i++){
				if (this.elForm.elements[i].name == name)
					return this.elForm.elements[i];
			}
		}
		return ret;

	},

	disable: function(name, disabled) {
		var el = this.element(name);
		el.disabled = disabled;
		if(Browser.isIE)
			if(disabled)
				el.style.className = "disabled";
			else
				el.style.className = "";
	},

	val: function(name) {
		return this._val(this.element(name));
	},

	_val: function(el) {
		if(el.type.search('select') >= 0) {
			if(el.type.search('one') >= 0)
				return this.selectedValue(el);
			else {
				if(el.getAttribute('multiple') != null){
					if(el.id == 'selectfrom')
						return
					else if(el.id == 'selectto')
						return this.getValues(el, true)
					return this.getValues(el);		/* a 'multiple' select */
				}
				else
					return this.selectedValue(el);
			}
		}
		else if(el.type.search('checkbox') >= 0)
			return el.checked;
		else
			return el.value;
	},

	selectall: function(name) {
		var el = this.element(name);
		for(var i = 0; i < el.options.length; i++)
			el.options[i].selected = true;
	},

	selectMultiple: function(name, values){
		var el = this.element(name);
		for(var i = 0; i < el.options.length; i++){
			if(values.indexOf(el.options[i].value) != -1)
				el.options[i].selected = true;
		}

	},
	getValues: function(el, multiselect) {
		var ret = [];
		for(var i = 0; i < el.options.length; i++) {
			if(el.options[i].selected || multiselect)
				ret.push(el.options[i].value);
		}
		return ret;
	},

	selectedValue: function(el) {
		if(el.selectedIndex == -1)
			return "";		// nothing selected (means the selectbox was empty)
		var selected = el.options[el.selectedIndex];
		if(selected.value != undefined)			/* XXX: selected.value != "". There are times when we *want* the value to be "". FUCK IE! */
			return "" + selected.value;
		return "" + selected.text;
	},

	response: function(data, stat) {
		if(stat == 200)
			this.submitted(data);
		else
			this.failed(data, stat);
	},

	cancel: function(evt) {
		if(evt.preventDefault)
			evt.preventDefault();
		window.location = this.cancelurl;
		return false;
	},

	extract: function() {
		var f = this.elForm;
		var parms = {};
		for(var i = 0; i < f.elements.length; i++) {
			var el = f.elements[i];
			if(el.type == 'radio') {
				if(el.checked)
					parms[el.name] = el.value;
			}
			else if(el.name != 'ignore' && el.type != 'submit' && el.type != 'button' && el.type != 'fieldset' && el.type != undefined){
				val = this._val(el);
				if(val != undefined)
					parms[el.name] = this._val(el);
			}
		}
		return parms;
	},

	flatten: function(input) {
		var output = [];

		for(var key in input) {
			var val = input[key];

			if(typeof(val) == 'object') {
				for(var c = 0; c < val.length; c++)
					output.push([key, val[c]]);
			}
			else if(typeof(val) == 'boolean') {
				/* booleans don't get sent unless they're true */
				if(val)
					output.push([key, val]);
			}
			else
				output.push([key, val]);
		}

		return output;
	},

	submit: function(evt) {
		if(evt.preventDefault)
			evt.preventDefault();

		var params = this.extract();
		params = this.validate(params);
		if(params) {
			if (typeof(this.elStatus) != 'undefined' && this.elStatus.type == 'submit'){
				var fa = DOM.style({'marginRight': '5px'}, DOM.I({'className': 'icon-spin icon-spinner icon-large'}, ''));
				var spanTxt = DOM.SPAN(null, this.sendText);
				while (this.elStatus.firstChild) {
					this.elStatus.removeChild(this.elStatus.firstChild);
				}
				DOM.addNodes(this.elStatus, fa, spanTxt);
			}
			else
				DOM.setTxt(this.elStatus, this.sendText);

			params = this.flatten(params);

			var data = '';
			for(var i = 0; i < params.length; i++) {
				if(i != 0)
					data += "&";
				data += params[i][0] + "=" + encodeURIComponent(params[i][1]);
			}

			Ajax.post(this.submiturl, data, this.response.bind(this));
		}

		return false;
	},

	validate: function(parms) {
		/* should be overridden by descendants of this class */
		return parms;
	},

	setstatus: function(stat) {
		DOM.setTxt(this.elStatus, stat);
		return null;		/* so that a validate method can call return this.setstatus('Error') to show the form is invalid. */
	},

	submitted: function(data) {
		if (typeof this.elStatus != 'undefined' && this.elStatus.type == 'submit'){
			var fa = DOM.style({'marginRight': '5px'}, DOM.I({'className': 'icon-thumbs-up'}, ''));
			var spanTxt = DOM.SPAN(null, "Done");
			while (this.elStatus.firstChild)
				this.elStatus.removeChild(this.elStatus.firstChild);
			DOM.addNodes(this.elStatus, fa, spanTxt);
		}
		else
			DOM.setTxt(this.elStatus, "Done");
	},

	failed: function(data, stat) {
		if (typeof this.elStatus != 'undefined' && this.elStatus.type == 'submit'){
				var fa = DOM.style({'marginRight': '5px'}, DOM.I({'className': 'icon-exclamation'}, ''));
				var spanTxt = DOM.SPAN(null, "Failed (" + stat + ")");
				while (this.elStatus.firstChild) {
					this.elStatus.removeChild(this.elStatus.firstChild);
}
				DOM.addNodes(this.elStatus, fa, spanTxt);
			}
			else
				DOM.setTxt(this.elStatus, "Failed (" + stat + ")");
	},

	clearErrors: function() {
		var f = this.elForm;
		for(var i = 0; i < f.elements.length; i++){
			if(f.elements[i].type != 'submit' && f.elements[i].className == 'error')
				f.elements[i].className = '';
		}
	},

	setError: function(name) {
		this.element(name).className = 'error';
		return true;
	}

});

